import { CredentialType } from "@api/shared-runtime/enums";
import type { Credential } from "@/features/credentials/types";

// Preserve the onboarding checklist while identifying evidence by its native
// credential type. A saved data-only record does not stand in for a document.
export const ONBOARDING_DOCUMENT_REQUIREMENTS = [
  {
    name: "Board Certification Status and Certificates",
    types: [CredentialType.BoardCertification],
  },
  { name: "CV with Relevant Work History", types: [CredentialType.Cv] },
  { name: "Diploma", types: [CredentialType.Education] },
  {
    name: "Government Issued ID",
    types: [
      CredentialType.GovernmentId,
      CredentialType.DriversLicense,
      CredentialType.Passport,
    ],
  },
  {
    name: "Health Screening Documents",
    types: [CredentialType.HealthScreening],
  },
  {
    name: "Malpractice Claims History",
    types: [CredentialType.MalpracticeClaimsHistory],
  },
  { name: "Medical License(s)", types: [CredentialType.StateLicense] },
  {
    name: "Residency/Fellowship Certificate",
    types: [CredentialType.Training],
  },
  {
    name: "DEA or CDS Certification",
    types: [CredentialType.Dea, CredentialType.Cds],
  },
];

export function missingOnboardingDocuments(
  credentials: Credential[],
): { name: string }[] {
  const heldDocumentTypes = new Set(
    credentials
      .filter(
        (credential) => credential.present && credential.documents.length > 0,
      )
      .map((credential) => credential.credentialType),
  );
  return ONBOARDING_DOCUMENT_REQUIREMENTS.filter(
    (requirement) =>
      !requirement.types.some((type) => heldDocumentTypes.has(type)),
  ).map(({ name }) => ({ name }));
}
